import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const authBasic = 'Basic c2VydmljZXM6MC49ajNEMnNzMS53Mjkt';

    let authReq: HttpRequest<any>;

    if (req.body instanceof FormData) {
      authReq = req.clone({
        headers: req.headers.set('Authorization', authBasic)
      });
    } else {
      authReq = req.clone({
        headers: req.headers
          .set('Authorization', authBasic)
          .set('Content-Type', 'application/json'),
      });
    }

    return next.handle(authReq);
  }
}



